import {Component, OnInit} from "@angular/core";
import {IUser} from "../../interfaces";
import {Compbaser} from "../compbaser";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute} from "@angular/router";
import {combineLatest, map} from "rxjs";
import {LocalStoreService, StoreSelectorsService} from "../../services";
import {CANVA_APP_BACKEND_URL, DEFAULT_PROTOCOL, DEFAULT_SERVER, isNullOrUndefOrEmpty} from "../../common";
import {Lib} from "../../../libs/Lib";

@Component({
    selector: "app-canva",
    templateUrl: "./canva.component.html",
    styleUrls: ["./canva.component.scss"],
})
export class CanvaComponent extends Compbaser implements OnInit {
    user: IUser;

    constructor(
        private storeSelector: StoreSelectorsService,
        private localStoreService: LocalStoreService,
        toastr: ToastrService,
        private route: ActivatedRoute
    ) {
        super();
        this.cod(
            combineLatest([
                this.route.queryParams,
                this.storeSelector.getUser(),
            ]).pipe(
                map(([routeParams, i_user]) => {
                    if (
                        !isNullOrUndefOrEmpty(i_user.username) &&
                        !isNullOrUndefOrEmpty(i_user.passwordNew)
                    ) {
                        return {
                            params: routeParams,
                            user: i_user,
                        };
                    }
                    return null;
                })
            ).subscribe((data) => {
                if (data) {
                    toastr.info("please wait a moment to auth Canva...");

                    setTimeout(() => {
                        const studioId = this.localStoreService.getStorageConfig().studioId;
                        const queryParams = {
                            ...data.params,
                            studioId,
                            studioApiBaseUrl: data.user.webApiBaseUrl,
                            website: `${DEFAULT_PROTOCOL}${DEFAULT_SERVER}/signstudio`,
                            username: data.user.username,
                            password: Lib.Base64().encode(data.user.passwordNew),
                        };
                        const query = new URLSearchParams(
                            queryParams
                        ).toString();

                        window.location.href = `${CANVA_APP_BACKEND_URL}/redirect-url?${query}`;
                    }, 2000);
                }
            })
        );
    }

    ngOnInit(): void {
    }
}
